import PassThruACHPage from "components/pages/PassThruACHPage";

export default function CapturePendingACHPassThru(props) {
    return <PassThruACHPage/>;
}